export enum AccionEliminar
{
  Excedido = 0,
  Vencido = 1,
  Ambos = 2
}
